import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const CalendarPlusIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.25 3C4.00736 3 3 4.00736 3 5.25L3 14.75C3 15.9926 4.00736 17 5.25 17H9.68903C9.56563 16.5206 9.5 16.0179 9.5 15.5H5.25C4.83579 15.5 4.5 15.1642 4.5 14.75L4.5 7L15.5 7V9.5C16.0179 9.5 16.5206 9.56563 17 9.68903V5.25C17 4.00736 15.9926 3 14.75 3L5.25 3Z"
          fill={color}
        />
        <path d="M11.5 10.75H10.5V11.75H11.5V10.75Z" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 15.5C20 17.9853 17.9853 20 15.5 20C13.0147 20 11 17.9853 11 15.5C11 13.0147 13.0147 11 15.5 11C17.9853 11 20 13.0147 20 15.5ZM15.5 12.5C15.7761 12.5 16 12.7239 16 13V15H18C18.2761 15 18.5 15.2239 18.5 15.5C18.5 15.7761 18.2761 16 18 16H16V18C16 18.2761 15.7761 18.5 15.5 18.5C15.2239 18.5 15 18.2761 15 18V16H13C12.7239 16 12.5 15.7761 12.5 15.5C12.5 15.2239 12.7239 15 13 15H15V13C15 12.7239 15.2239 12.5 15.5 12.5Z"
          fill={color}
        />
        <path d="M8.5 8.75H9.5V9.75H8.5V8.75Z" fill={color} />
        <path d="M7.5 10.75H6.5V11.75H7.5V10.75Z" fill={color} />
        <path d="M6.5 12.75H7.5V13.75H6.5V12.75Z" fill={color} />
        <path d="M8.5 10.75H9.5V11.75H8.5V10.75Z" fill={color} />
        <path d="M8.5 12.75H9.5V13.75H8.5V12.75Z" fill={color} />
        <path d="M10.5 8.75H11.5V9.75H10.5V8.75Z" fill={color} />
        <path d="M13.5 8.75H12.5V9.75H13.5V8.75Z" fill={color} />
      </svg>
    </Icon>
  </>
)
